import React from 'react'

const PlatformWithAvatars = ({ emotion, memory, dialogueIndex }) => {
    if (memory?.hasFlowers && !emotion?.mariam) {
        emotion = { ...emotion, mariam: 'flowers' }
    }

    let flowersAttack = false;

    if (emotion?.mariam === 'flowers-attack') {
        flowersAttack = true;
    }
    return (
        <div className='flex z-30 fixed w-full h-full justify-center items-center transition-all'>
            <div className='idle-animation flex flex-col gap-4 justify-center items-center w-96 h-96'>
                <div className={`grid grid-cols-2 transition-all ${dialogueIndex > 7 && dialogueIndex < 20 && '-translate-x-full'}`}>
                    <div className='w-full h-full relative flex'>
                        <img src='./sprites/kean_avatar.png' alt='kean' className='w-full h-full' />
                        {emotion?.kean && <img src={`./sprites/${emotion.kean}.png`} alt={emotion.kean} className={`absolute top-0 left-0 ${emotion.kean}`} />}
                    </div>
                    <div className='w-full h-full relative flex'>
                        <img src='./sprites/mariam_avatar.png' alt='mariam' className='w-full h-full' />
                        {console.log(emotion?.mariam)}
                        {console.log(memory)}
                        {flowersAttack &&
                            <div className='reveal-container absolute top-0 left-0'>
                                <img src={`./sprites/${emotion.mariam}.png`} alt={emotion.mariam} className={`${emotion.mariam}`} />
                            </div>}
                        {emotion?.mariam && !flowersAttack && (emotion?.mariam === 'flowers' ? memory.hasFlowers : true) && <img src={`./sprites/${emotion.mariam}.png`} alt={emotion.mariam} className={`absolute top-0 left-0 ${emotion.mariam}`} />}
                    </div>
                </div>
                <img src='./sprites/grass-platform.png' alt='platform' className={`transition-all ${dialogueIndex > 7 && dialogueIndex < 20 &&  '-translate-x-3/4'}`} />
            </div>
            <div className={`idle-animation absolute transition-all ${dialogueIndex > 7 && dialogueIndex < 20 ? 'right-20' : '-right-full'}`}>
                <img src='./sprites/jaden.png' alt='jaden' />
            </div>
        </div>
    )
}

export default PlatformWithAvatars